import React, { useEffect } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import styled from 'styled-components';

import Column from 'components/common/Column';
import IndividualUpdateContainer from 'containers/Menu/components/IndividualUpdateContainer';
import HackleManager from 'utils/hackle';
import { MAX_WIDTH } from 'App';
import ContentsTopBar from 'components/common/ContentsTopBar';
import WrapperContainer from 'components/common/Wrapper';

const Container = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: ${props => (props.$isMobile ? '0 0 90px' : '0 0 40px')};
  width: 100%;
  max-width: 768px;
  min-height: 100vh;
  background-color: #fff;
`;

const IndividualPage = () => {
  const { width, ref } = useResizeDetector();

  const isMobile = width ? width <= MAX_WIDTH : window.innerWidth <= MAX_WIDTH;

  useEffect(() => {
    HackleManager.logIndividualView();
  }, []);

  return (
    <WrapperContainer isMobile={isMobile}>
      <Container ref={ref} $isMobile={isMobile}>
        <ContentsTopBar isMobile={isMobile} title="호스트 연락처 설정" />
        <Column>
          <IndividualUpdateContainer isMobile={isMobile} isPage={true} />
        </Column>
      </Container>
    </WrapperContainer>
  );
};

export default IndividualPage;
